import { render } from "./OtherContent.vue?vue&type=template&id=33c9e8b8"
import script from "./OtherContent.vue?vue&type=script&lang=js"
export * from "./OtherContent.vue?vue&type=script&lang=js"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__